import { Injectable } from '@angular/core';
import { SubscriptionRepository } from '../infrastructure/repositories/subscription.repository';
import { Observable, BehaviorSubject, Subscription } from 'rxjs';
import { PaymentService } from './payment-service';
import { MyTicketResponse } from '../model/interfaces/my-ticket-response';
import { PlayerService } from './player.service';
import { GetTicketOwnershipsResponse } from '../model/interfaces/ticket-ownerships-get-response';

@Injectable({
    providedIn: 'root'
})
export class SubscriptionService
{
    private readonly repository: SubscriptionRepository;
    private paymentService: PaymentService;
    private myTicketSubject: BehaviorSubject<MyTicketResponse>;
    private subscriptionsSubject: BehaviorSubject<GetTicketOwnershipsResponse>;
    private bsMandateCreatedsubscription: Subscription;
    private fmtCompletedsubscription: Subscription;
    private playerService: PlayerService;

    public constructor(
        repository: SubscriptionRepository,
        paymentService: PaymentService,
        playerService: PlayerService

    )
    {
        this.repository = repository;
        this.paymentService = paymentService;
        this.playerService = playerService;
        this.init();
    }

    private init(): void
    {
        this.bsMandateCreatedsubscription = this.paymentService.bsMandateCreated.subscribe(() => { this.fetchMyTicket(); });
        this.fmtCompletedsubscription = this.paymentService.fmtPaymentCompleted.subscribe(() => { this.fetchMyTicket(); });

        // listen for player-logout in order to clear mytickets
        this.playerService.onPlayerLoggedOutNotification.subscribe((options) =>
        {
            this.myTicketSubject.next(null);
            this.myTicketSubject = null;
            this.subscriptionsSubject.next(null);
            this.subscriptionsSubject = null;
        });
    }

    private fetchMyTicket(): void
    {
        this.repository.getMyTickets().subscribe(myTickets => { this.myTicketSubject.next(myTickets); } );
    }

    public getMyTickets(): Observable<MyTicketResponse>
    {
        if (this.myTicketSubject != null)
        {
            return this.myTicketSubject.asObservable();
        }

        this.myTicketSubject = new BehaviorSubject<MyTicketResponse>(null);
        this.fetchMyTicket();

        return this.myTicketSubject.asObservable();
    }

    public getTicketOwnerships(): Observable<GetTicketOwnershipsResponse>
    {
        if (this.subscriptionsSubject != null)
        {
            return this.subscriptionsSubject.asObservable();
        }

        this.subscriptionsSubject = new BehaviorSubject<GetTicketOwnershipsResponse>(null);
        this.repository.getTicketOwnerships().subscribe(subscriptions => { this.subscriptionsSubject.next(subscriptions); } );

        return this.subscriptionsSubject.asObservable();
    }

    public updateTicketOwnershipPaymentMethod(playerId: number, ticketNumber: number, ticketLetter: string, paymentMethodId: any): Observable<GetTicketOwnershipsResponse>
    {
        return this.repository.updateTicketOwnershipPaymentMethod(playerId, ticketNumber, ticketLetter, paymentMethodId);
    }

    public cancelTicketOwnership(playerId: number, ticketNumber: number, ticketLetter: string): Observable<GetTicketOwnershipsResponse>
    {
        return this.repository.cancelTicketOwnership(playerId, ticketNumber, ticketLetter);
    }

    public unsubscribeNewsletter(email: string): Observable<boolean>
    {
        return this.repository.unsubscribeNewsletter(email);
    }
}
